/**
 * Setup of options for axios fetch.
 *
 * Warning: If we go back to fetch, make sure to change:
 *
 *   1) headers (not a plain object in fetch) and
 *   2) credentials are "withCredentials: true" in fetch, "credentials: 'include'" in axios.
 */

import {isVerboseLoggingEnabled} from '../error/reportError';

export const LOGIN_TIMEOUT_MS = 30000;

// Timeout gated behind the `login-verbose-logging` webfeature.
// Axios treats a timeout of 0 as "no timeout":
const requestTimeout = () => (isVerboseLoggingEnabled() ? LOGIN_TIMEOUT_MS : 0);

export const get = config => {
  return {
    method: 'GET',
    mode: 'cors',
    headers: {'Content-Type': 'application/json; charset=UTF-8'},
    withCredentials: true,
    timeout: requestTimeout(),
    ...config,
  };
};

export const post = config => {
  return {
    method: 'POST',
    mode: 'cors',
    headers: {'Content-Type': 'application/json; charset=UTF-8'},
    withCredentials: true,
    timeout: requestTimeout(),
    data: {},
    ...config,
  };
};

export const imagePost = config => {
  return {
    method: 'POST',
    mode: 'cors',
    withCredentials: true,
    ...config,
  };
};

export const del = config => {
  return {
    method: 'DELETE',
    mode: 'cors',
    headers: {'Content-Type': 'application/json; charset=UTF-8'},
    withCredentials: true,
    timeout: requestTimeout(),
    ...config,
  };
};

export const patch = config => {
  return {
    method: 'PATCH',
    mode: 'cors',
    headers: {'Content-Type': 'application/json; charset=UTF-8'},
    withCredentials: true,
    timeout: requestTimeout(),
    body: JSON.stringify({}),
    ...config,
  };
};
